<template>
  <v-toolbar dense class="secondary elevation-0">
    <v-toolbar-title>
      <BTooltipButton
        icon="mdi-close"
        depressed
        rounded
        small
        top
        class-button="NotificationsMenu__close"
        @click="$emit('close')"
      />
      <span class="NotificationsMenu__title">{{ title }}</span>
    </v-toolbar-title>

    <v-spacer />

    <div class="NotificationsMenu__check-all">
      <BTooltipButton
        v-if="unread_count"
        :loading="isLoading"
        icon="mdi-checkbox-multiple-marked-outline"
        tooltip="Прочитать все"
        depressed
        small
        rounded
        left
        @click="$emit('action:readed', toggleLoading)"
      />
    </div>

    <div v-if="count" class="ml-2 NotificationsMenu__counts">
      <span>{{ count }} </span>
      <span class="unread-msgs">
        <template v-if="unread_count">+ </template>
        {{ unread_count }}
      </span>
    </div>
  </v-toolbar>
</template>

<script>
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'NotificationsToolbar',
  components: {
    BTooltipButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    unread_count: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>
